import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="flex items-center justify-center min-h-[50vh] text-brown-500" data-testid="loading-state">
        <span className="animate-pulse">Loading…</span>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (adminOnly && !["admin", "moderator"].includes(user.role)) {
    return <Navigate to="/matches" replace />;
  }
  return children;
}
